import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const communicationsStatusPageCreateRoute: InvariantJiraRoute = {
	name: 'communications-status-page-create',
	path: '/jira/communications/status-page/create',
};
